export enum AuthenticationEventMessages {
  LOGIN_PROCESSING = 'authenticationEventMessages/loginProcessing',
  LOGIN_SUCCESS = 'authenticationEventMessages/loginSuccess',
  LOGIN_ERROR = 'authenticationEventMessages/loginError',
  LOGOUT_SUCCESS = 'authenticationEventMessages/logoutSuccess',
  REFRESH_TOKEN_ERROR = 'authenticationEventMessages/token/refreshError',
}
